import { process } from "am-tax-fe-core";

import { components } from "../generated/generated-api";
import { client } from "../entities/entityApi";

//#region Dto definition
export type ReportTransaction = components["schemas"]["ReportTransactionDto"];
export type CreateReportTransaction = components["schemas"]["CreateOrUpdateReportTransactionDto"];
export type UpdateReportTransaction = components["schemas"]["CreateOrUpdateReportTransactionDto"];

export const getReportTransactionsAsync = async (): Promise<ReportTransaction[]> => process(client().GET("/api/reporttransactions"));

export const getReportTransactionsByReportIdAsync = async (reportId: string): Promise<ReportTransaction> =>
    process(
        client().GET("/api/reporttransactions/{reportId}", {
            params: {
                path: {
                    reportId,
                },
            },
        }),
    );

export const getReportTransactionAsync = async (reportId: string): Promise<ReportTransaction> =>
    process(
        client().GET("/api/reporttransactions/{reportId}", {
            params: {
                path: {
                    reportId,
                },
            },
        }),
    );

export const createReportTransactionAsync = async (args: CreateReportTransaction): Promise<ReportTransaction> =>
    process(client().POST("/api/reporttransactions", { body: args }));

export const updateReportTransactionAsync = async (reportId: string, args: UpdateReportTransaction): Promise<ReportTransaction> =>
    process(
        client().PUT("/api/reporttransactions/{reportId}", {
            params: {
                path: {
                    reportId,
                },
            },
            body: args,
        }),
    );

export const deleteReportTransactionAsync = async (reportId: string): Promise<void> =>
    process(
        client().DELETE("/api/reporttransactions/{reportId}", {
            params: {
                path: {
                    reportId,
                },
            },
        }),
    );
